import request from '@/utils/request';
import {
  endpoints,
  workspaceFormEndpoint, workspaceLocationsEndpoint,
  workspacesEndpoint,
} from '@/constants/urls';
import { transformForm } from '@/forms/state/state';
import { hasMinimumLength } from '@/utils/resultsHelper';
import { workspaceReferenceFieldCode } from './constants';

const workspacesForm = (code) => request({
  url: workspaceFormEndpoint(code),
  method: 'GET',
});

const workspacesFormHealthCheck = (code) => request({
  url: `${workspaceFormEndpoint(code)}/health/`,
  method: 'GET',
});

const workspacesLocations = (entity, code) => request({
  url: workspaceLocationsEndpoint(entity, code),
  method: 'GET',
});

const workspaces = (entity, code, location) => (
  request({
    url: workspacesEndpoint(entity, code),
    params: hasMinimumLength(location) ? { location } : null,
    method: 'GET',
  })
);

const create = ({ fields }) => {
  const data = { reference: fields[workspaceReferenceFieldCode], fields: transformForm(fields) };
  delete data.fields[workspaceReferenceFieldCode];

  return request({ url: endpoints.WORKSPACES, data, method: 'POST' });
};

const WorkspacesService = {
  create,
  workspaces,
  workspacesLocations,
  workspacesForm,
  workspacesFormHealthCheck,
};

export default WorkspacesService;
